// extracted by mini-css-extract-plugin
export var active = "_az-a";
export var activeIndicator = "_az-8";
export var animate = "_az-9";
export var disabled = "_az-b";
export var fullWidth = "_az-2";
export var lg = "_az-7";
export var md = "_az-6";
export var redoButtonTabGroup = "_az-0";
export var sm = "_az-5";
export var tabButton = "_az-3";
export var tabButtonsContainer = "_az-1";
export var xs = "_az-4";